import { PaginationProperties } from '../../../shared/uiComponents/Table/tableProperties';
import { DASHBOARD } from '../constants';
import { FetchAPI } from '../Main/fetchAPI';

export const Dashboard = {
	getTemporaryAuthorizations: (data: PaginationProperties) => {
		const { page, pageSize } = data;
		const query = new URLSearchParams();

		if (page) query.set('page', page);
		if (pageSize) query.set('pageSize', pageSize);

		return FetchAPI.getJson({
			urlStr: `${DASHBOARD}/temporary-authorizations?${query.toString()}`,
		});
	},
	getFlaggedSessions: (data: PaginationProperties) => {
		const { page, pageSize } = data;
		const query = new URLSearchParams();

		if (page) query.set('page', page);
		if (pageSize) query.set('pageSize', pageSize);

		return FetchAPI.getJson({
			urlStr: `${DASHBOARD}/flagged-sessions?${query.toString()}`,
		});
	},
	getAuthorizationInfoAdmin: (data: PaginationProperties) => {
		const { page, pageSize, direction, orderBy, searchString } = data;
		const query = new URLSearchParams();

		if (searchString) query.set('searchString', searchString);
		if (direction) query.set('direction', direction);
		if (orderBy) query.set('orderBy', orderBy);
		if (page) query.set('page', page);
		if (pageSize) query.set('pageSize', pageSize);

		return FetchAPI.getJson({
			urlStr: `${DASHBOARD}/admin?${query.toString()}`,
		});
	},
	getAuthorizationInfoClinicalSupervisor: ({ data, userId }: { data: PaginationProperties; userId: string }) => {
		const { page, pageSize, direction, orderBy, searchString } = data;
		const query = new URLSearchParams();

		if (userId) query.set('userId', userId);
		if (searchString) query.set('searchString', searchString);
		if (direction) query.set('direction', direction);
		if (orderBy) query.set('orderBy', orderBy);
		if (page) query.set('page', page);
		if (pageSize) query.set('pageSize', pageSize);

		return FetchAPI.getJson({
			urlStr: `${DASHBOARD}/clinical-supervisor?${query.toString()}`,
		});
	},
  getBcbaDashboard: () => {
    return FetchAPI.getJson({
      urlStr: `${DASHBOARD}/bcba`,
    });
  },
  getBcbaClientGoals: (clientId: string) => {
    return FetchAPI.getJson({
      urlStr: `${DASHBOARD}/bcba/clients/${clientId}/goals`,
    });
  },
  getBcbaClientAuthorizationDetail: (clientId: string) => {
    return FetchAPI.getJson({
      urlStr: `${DASHBOARD}/bcba/clients/${clientId}/authorization-detail`,
    });
  },
  getBtDashboard: () => {
    return FetchAPI.getJson({
      urlStr: `${DASHBOARD}/bt`,
    });
  },
  getCsDashboard: () => {
    return FetchAPI.getJson({
      urlStr: `${DASHBOARD}/cs`,
    });
  },
  getCsFlaggedSessions: () => {
    return FetchAPI.getJson({
      urlStr: `${DASHBOARD}/cs-flagged-sessions`,
    });
  },
};
